module.exports = __webpack_public_path__ + "img/halfwaystation.d502f7be.png";